import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

const useToggleSuperAdminMutate = () => {
	const http = useHttpClient('v2');
	return useMutation(() => http.patch(`super_admin/toggle_controls`));
};

export const useToggleSuperAdmin = (onSuccess: () => void) => {
	const { mutate } = useToggleSuperAdminMutate();
	return () => mutate(undefined, { onSuccess });
};
